import { ENVIRONMENT_PATHS } from '@/config/enums';

export default (): string => {
  const isTest = location.pathname.includes(ENVIRONMENT_PATHS.TEST);
  return isTest ? ENVIRONMENT_PATHS.TEST : ENVIRONMENT_PATHS.APP;
};
